import { Grid } from '@mui/material';
import { ODSCheckmark } from '@telekom-ods/react-icons';
import { ODSButton, ODSGrid } from '@telekom-ods/react-ui-kit';
import { useState } from 'react';
import { useIntl } from 'react-intl';

import compute from '../../../assets/images/compute.svg';
import BreadCrumb from '../../../components/BreadCrumb';
import { getTheme } from '../../../helpers/theme';
import useAppContext from '../../../hooks/useAppContext';
import useMarkdownFile from '../../../hooks/useMarkdownFile';
import computeEvaluationSpecificationDe from '../../../markdowns/Compute/evaluation.de.md';
import computeEvaluationSpecificationEn from '../../../markdowns/Compute/evaluation.md';
import specificationIntroDe from '../../../markdowns/Compute/intro.de.md';
import specificationIntroEn from '../../../markdowns/Compute/intro.md';
import computeProductSpecificationDe from '../../../markdowns/Compute/product.de.md';
import computeProductSpecificationEn from '../../../markdowns/Compute/product.md';
import SpecificationContent from '../SpecificationContent';

import ComputeContent from './ComputeContent';

const ComputeSpecification = () => {
  const [activeContent, setActiveContent] = useState('product');
  const { theme } = useAppContext();
  const intl = useIntl();
  const isGerman = intl.locale === 'de';
  const specificationIntro = isGerman ? specificationIntroDe : specificationIntroEn;
  const computeProductSpecification = isGerman
    ? computeProductSpecificationDe
    : computeProductSpecificationEn;
  const computeEvaluationSpecification = isGerman
    ? computeEvaluationSpecificationDe
    : computeEvaluationSpecificationEn;
  const { markdownContent: specificationIntroMarkDownContent } =
    useMarkdownFile(specificationIntro);

  return (
    <SpecificationContent
      logo={{
        src: compute,
        alt: intl.formatMessage({ id: 'computeLogoAlt' }),
      }}
      content={
        <>
          <BreadCrumb
            items={[
              {
                href: '/',
                text: intl.formatMessage({ id: 'title' }),
              },
              {
                href: '#',
                text: intl.formatMessage({ id: 'computeProductSpecificationBreadcrumb' }),
              },
            ]}
          />
          <Grid
            container
            columnGap={0}
            columnSpacing={0}
            justifyContent='space-between'
            style={{
              margin: '0',
            }}
          >
            <Grid item>{specificationIntroMarkDownContent}</Grid>
            <Grid>
              <ODSGrid
                className='specification_wrapper{'
                container
              >
                <ODSGrid columns={5}>
                  <ODSButton
                    rightIcon
                    {...(activeContent === 'product' && {
                      buttonIcon: <ODSCheckmark />,
                    })}
                    buttonType='standard'
                    label={intl.formatMessage({ id: 'commercialProduct' })}
                    size='small'
                    variant={activeContent === 'product' ? getTheme(theme) : 'outline'}
                    onClick={() => {
                      setActiveContent('product');
                    }}
                  />
                </ODSGrid>
                <ODSGrid columns={5}>
                  <ODSButton
                    rightIcon
                    {...(activeContent === 'evaluation' && {
                      buttonIcon: <ODSCheckmark />,
                    })}
                    label={intl.formatMessage({ id: 'evaluationProductLabel' })}
                    variant={activeContent === 'evaluation' ? getTheme(theme) : 'outline'}
                    size='small'
                    onClick={() => {
                      setActiveContent('evaluation');
                    }}
                  />
                </ODSGrid>
              </ODSGrid>
            </Grid>
            <ComputeContent
              activeContent={
                activeContent === 'product'
                  ? computeProductSpecification
                  : computeEvaluationSpecification
              }
            />
          </Grid>
        </>
      }
    />
  );
};

export default ComputeSpecification;
